import React from 'react';

/**
 * BrandLogo – offizielles DolmetschDirekt-Logo
 * Nutzt die SVG aus /public/logo.svg (Sprechblasen + Text)
 *
 * Variants:
 *  - "full" (default): Volles Logo mit Text (SVG aus /logo.svg)
 *  - "icon": Nur die Sprechblasen (SVG aus /logo-icon.svg) – ideal für kleine Plätze
 */
export const BrandLogo = ({ variant = 'full', className = '', height }) => {
  const src = variant === 'icon' ? '/logo-icon.svg' : '/logo.svg';
  const defaultHeight = variant === 'icon' ? 32 : 40;
  return (
    <img
      src={src}
      alt="DolmetschDirekt"
      height={height || defaultHeight}
      className={className}
      style={{ height: height || defaultHeight }}
      data-testid="brand-logo"
    />
  );
};

export default BrandLogo;
